import axios from 'axios';

import accessLocalStorage from './accessLocalStorage';

export const chartEndpointsReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/receiveds/endpoints`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartEndpointsReceiveds:', error);
    throw error;
  }
};

export const chartHoursReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/receiveds/hours`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartHoursReceiveds:', error);
    throw error;
  }
};

export const chartSectorsReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/receiveds/sectors`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartSectorsReceiveds:', error);
    throw error;
  }
};

export const chartSectorsGlobal = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/receiveds/globalqueues`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartSectorsGlobal:', error);
    throw error;
  }
};

export const chartDaysReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/receiveds/days`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartDaysReceiveds:', error);
    throw error;
  }
};

export const chartResumeReceiveds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/receiveds/resume`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartResumeReceiveds:', error);
    throw error;
  }
};

export const chartEndpointsSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/sendeds/endpoints`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartEndpointsSendeds:', error);
    throw error;
  }
};

export const chartHoursSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/sendeds/hours`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartHoursSendeds:', error);
    throw error;
  }
};

export const chartSectorsSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/sendeds/sectors`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartSectorsSendeds:', error);
    throw error;
  }
};

export const chartDaysSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/sendeds/days`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartDaysSendeds:', error);
    throw error;
  }
};

export const chartResumeSendeds = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/sendeds/resume`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartResumeSendeds:', error);
    throw error;
  }
};

export const logsReport = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;

  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/logs`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em logsReport:', error);
    throw error;
  }
};

export const chartResumeInternals = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  dataRequest['endpointsviewer'] = endpointsviewer;
  dataRequest['queuesviewer'] = queuesviewer;
  dataRequest['tenantId'] = idtenant;
  
  try {
    const response = await axios
      .post(`//${ipClean}/relatorio/internals/resume`, dataRequest, { 
        headers: { Authorization: token },
        timeout: 30000
      });
    return response.data;
  } catch (error) {
    console.error('[API] Erro em chartResumeInternals:', error);
    throw error;
  }
};

export const createTenant = async (dataRequest) => {
  const { token, ipRequest, user: { endpointsviewer, queuesviewer, idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];

  try {
    const response = await axios
      .post(`//${ipClean}/api/tenants/create`, dataRequest, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const readAllTenant = async (dataRequest) => {
  const { token, ipRequest } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios.get(`//${ipClean}/api/tenants`,  { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const listFilesUploaded = async (dataRequest) => {
  const { token, ipRequest, user: { idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios.post(`//${ipClean}/api/uploads/list`, { tenant: idtenant }, { headers: { Authorization: token } });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const downloadFileTenants = async (dataRequest) => {
  const { token, ipRequest, user: { idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios.post(`//${ipClean}/api/uploads/download`, dataRequest, { headers: { Authorization: token }, responseType: 'blob' });
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteFileTenant = async (dataRequest) => {
  const { token, ipRequest, user: { idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const response = await axios.post(`//${ipClean}/api/uploads/delete`, dataRequest, { headers: { Authorization: token } });
    return response;
  } catch (error) {
    return error;
  }
};

export const playFileTenant = async (dataRequest) => {
  const { token, ipRequest, user: { idtenant } } = await accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  
  try {
    const { tenant, folder, fileName } = dataRequest;
    return `//${ipClean}/api/uploads/play?tenant=${tenant}&type=${folder}&fileName=${fileName}`;
  } catch (error) {
    return error;
  }
};
